import styled from 'styled-components'
import { IconButton as MuiIconButton } from '@material-ui/core'

export const VideoContainer = styled.div<{ isplaying?: number }>`
  position: relative;
  cursor: ${({ isplaying }) => (isplaying === 0 ? 'inherit' : 'pointer')};
`

export const PlayButton = styled.div`
  position: absolute;
  left: 50%;
  margin-left: -25px;
  top: 50%;
  margin-top: -40px;
`

export const IconButton = styled(MuiIconButton)`
  padding: 20px;
  opacity: 0.8;
  &:hover {
    opacity: 0.7;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    padding: 12px;
  }
`
